export const ENABLED = "enabled"
export const DISABLED = "disabled"
export const FINISHED = "finished"
export const ARCHIVED = "archived"
export const DELETED = "deleted"

export const READY_TO_LAUNCH = "readyToLaunch"
export const SAVED_AS_DRAFT = "savedAsDraft"
export const LAUNCHED = "launched"
export const STOPPED = "stopped"
export const IN_PROGRESS = "inProgress"

export const STATUSES = [ENABLED, DISABLED, ARCHIVED, FINISHED, DELETED]
export const VALIDATION_STATUSES = [READY_TO_LAUNCH, SAVED_AS_DRAFT, IN_PROGRESS, LAUNCHED, STOPPED, ARCHIVED]

export const VALIDATION_STATUS_DRAFT = [READY_TO_LAUNCH, SAVED_AS_DRAFT]

export const PLACEHOLDER_SCHEDULE_ID = "00000000-0000-0000-0000-000000000000"
export const CUSTOM_INTEREST_CONTENT_ID = "insights.areaOfInterest.custom"
